export const getCachedOidcUser = () => {
  const raw = localStorage.getItem("oidcUserData");
  return raw ? JSON.parse(raw) : null;
};
